<script setup lang="ts">
import EditableNotesField from '@/components/rc/common/EditableNotesField.vue'
import RepairSection from '@/components/rc/miner-repairs/repairs-sidebar/RepairSection.vue'
import { useMinerDetails } from '@/composables/rc/miner-details'
import { useMinerRepairActions } from '@/composables/rc/miner-repair-actions'
import { toRefs } from 'vue'

const props = defineProps<{ minerId: number }>()
const { minerId } = toRefs(props)

const { minerDetailsQuery } = useMinerDetails(minerId)
const { data: minerDetails } = minerDetailsQuery

const { updateRepairNotesMutation } = useMinerRepairActions(minerId)

const saveRepairNotes = (text: string, discardNotes: () => void) => {
  updateRepairNotesMutation.mutate({ repair_notes: text }, { onError: discardNotes })
}
</script>

<template>
  <RepairSection title="Repair Notes" :step="5" :active="!!minerDetails?.repair_notes">
    <EditableNotesField
      :cache-value="minerDetails?.repair_notes ?? ''"
      placeholder="Enter repair notes..."
      style="width: 100%"
      @save="saveRepairNotes"
    />
  </RepairSection>
</template>

<style scoped lang="scss">
.el-textarea.repair-notes {
  background-color: var(--fill-primary);
}

.el-text.repair-notes {
  display: inline-block;
  background-color: var(--fill-primary);
  width: 100%;
  height: 100%;
  border: 1px solid var(--component-stroke-primary);
  padding: var(--spacing-spacing-2xs);
  border-radius: var(--spacing-spacing-2xs);
  color: var(--text-placeholder);
}
</style>
